__turbopack_context__.v({
  "backdrop": "RegaloModal-module__fefyma__backdrop",
  "closeButton": "RegaloModal-module__fefyma__closeButton",
  "ctaButton": "RegaloModal-module__fefyma__ctaButton",
  "fadeIn": "RegaloModal-module__fefyma__fadeIn",
  "featureIcon": "RegaloModal-module__fefyma__featureIcon",
  "featureItem": "RegaloModal-module__fefyma__featureItem",
  "featureList": "RegaloModal-module__fefyma__featureList",
  "featureStrong": "RegaloModal-module__fefyma__featureStrong",
  "featureText": "RegaloModal-module__fefyma__featureText",
  "giftIconOnly": "RegaloModal-module__fefyma__giftIconOnly",
  "modalCard": "RegaloModal-module__fefyma__modalCard",
  "planName": "RegaloModal-module__fefyma__planName",
  "planTag": "RegaloModal-module__fefyma__planTag",
  "promoCard": "RegaloModal-module__fefyma__promoCard",
  "promoHeader": "RegaloModal-module__fefyma__promoHeader",
  "subtitle": "RegaloModal-module__fefyma__subtitle",
  "title": "RegaloModal-module__fefyma__title",
  "titleHighlight": "RegaloModal-module__fefyma__titleHighlight",
  "zoomIn": "RegaloModal-module__fefyma__zoomIn",
});
